import type React from 'react';
import { type ChangeEvent } from 'react';

import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';

import { useStyles } from './styles';

type Option = {
  value: string;
  label: any;
  disable?: boolean;
};

type Props = {
  className?: string;
  options: Option[];
  isRow?: boolean;
  id?: string;
  props?: any;
  radioColor?: 'error' | 'primary' | 'secondary' | 'info' | 'success' | 'warning' | 'default';
  value: string;
  handleChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  field?: {
    name: string;
    value: string;
  };
};

const RadioButtonGroup: React.FC<React.PropsWithChildren<Props>> = ({
  className,
  options,
  value,
  radioColor,
  isRow,
  id,
  handleChange,
  field,
  ...props
}: Props) => {
  const { classes } = useStyles();

  return (
    <FormControl component="fieldset">
      <RadioGroup
        aria-label={value}
        className={className}
        id={id}
        row={isRow}
        value={value}
        onChange={handleChange}
        {...field}
        {...props}
      >
        {options.map((option) => (
          <FormControlLabel
            key={option.value}
            classes={{ root: classes.label }}
            control={
              <Radio
                disableRipple
                classes={{
                  root: classes.radioButton,
                  checked: classes.checked,
                  colorSecondary: classes.radioButton,
                }}
                className={classes.radioButton}
                color={radioColor || 'default'}
                disabled={option.disable}
              />
            }
            label={option.label}
            value={option.value}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default RadioButtonGroup;
